export const editMode = {
  EDIT_GROUP: 'EDIT_GROUP',
  SELECT_GROUP: 'SELECT_GROUP',
}

export const locationGroupType = {
  ALL: 'all',
  CUSTOM_LOCATION: 'custom_location',
  POI_LOCATION: 'poi_location',
}

export const locationFilter = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}
